<div class="warning-box" [ngClass]="{ 'visible': Visible }">
    <ion-item [ngClass]="color ? color : 'primary'" lines="none">
        <ion-icon *ngIf="icon" [class]="slot" [slot]="slot" [name]="icon"></ion-icon>
        <ion-label *ngIf="title">
            {{title}}
            <span *ngIf="subtitle" class="small"><br/>{{subtitle}}</span>
        </ion-label>
    </ion-item>
</div>
